import { Controller } from "@hotwired/stimulus";
import { checkNewReferralFormSubmitButton } from "../helpers";
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static targets = [
    "referralForm",
    "inputOrganizationWrapper",
    "inputOrganization",
    "hiddenInputOrganizationId",
    "dropzone",
    "referredOrganizationDzItems",
    "referredOrganizationFieldsWrapper",
    "addNewOrganizationBtn",
    "chooseExistingOrganizationBtn",
    "inputReferredProvider",
    "hiddenInputReferredProviderIds",
    "chooseExistingReferredProviderBtn",
    "addNewReferredProviderBtn",
    "referredProviderBtnsWrapper",
    "addReferredProviderWrapper",
    "referredProviderFieldsWrapper",
    "anyProviderRadioBtn",
    "submitBtn",
    "referredProviderListDropzone",
    "referredProviderDzItems",
    "newOrganizationEmail",
    "newOrganizationName",
    "specificProviderRadioBtn",
    "addEmail",
    "customSelectWrapper",
    "referredProviderTypeHidden",
    "sharedProviderField",
    "inputReferredLocation",
    "hiddenInputReferredLocationIds",
    "locationLimitWarning",
    "providerLimitWarning"
  ];

  // Stash for the recipient fields (organization vs. office email) so the
  // inactive mode's values survive a toggle without being submitted on the
  // referral. Lives on document.body, which Turbo Drive replaces on a real
  // navigation (resetting the stash per referral) but keeps across the in-frame
  // form re-render that happens when switching modes.
  get preservedRecipientFields() {
    if (!document.body._preservedRecipientFields) {
      document.body._preservedRecipientFields = {};
    }
    return document.body._preservedRecipientFields;
  }

  getOverlayController() {
    if (!this.overlayController) {
      const overlayElement = document.querySelector('[data-controller="referral-overlay"]');
      if (overlayElement) {
        this.overlayController = this.application.getControllerForElementAndIdentifier(overlayElement, 'referral-overlay');
      }
    }
    return this.overlayController;
  }

  hideOverlay() {
    // console.log(123)
    // const controller = this.getOverlayController();
    // if (controller) {
    //   controller.hide();
    // }
    document.querySelector('.overlay-container').classList.add('d-none')
  }

  showOverlay() {
    // const controller = this.getOverlayController();
    // console.log(1234, controller)
    // if (controller) {
    //   controller.show();
    // }
    document.querySelector('.overlay-container').classList.remove('d-none')

  }

  connect() {
    // Add this flag to prevent infinite loops
    if (this.element.dataset.organizationProcessed === 'true') {
      return;
    }

    this.overlayController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller~="referral-overlay"]'),
      'referral-overlay'
    );

    this.initializeTooltips();

    // Check if this is an embedded form
    this.isEmbeddedForm = this.element.hasAttribute('data-embedded-form') || 
                          this.element.closest('[data-embedded-form="true"]') !== null;

    if (this.isEmbeddedForm) {
      // Get the organization ID from the hidden field
      const organizationIdField = document.querySelector('input[name="referral[referred_organization_id]"]');

      if (organizationIdField && organizationIdField.value) {
        // Load locations and providers for this organization
        this.getReferredLocations(organizationIdField.value);
        this.getReferredProviders(organizationIdField.value);
      }
    } else {
      // Check for URL parameters from referral parners
      this.checkForURLParameters();
    }
  }

  // From referral partners, send to specific organization
  checkForURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const organizationId = urlParams.get('organization_id');
    
    if (organizationId) {
      this.element.dataset.organizationProcessed = 'true';
      
      if (this.hasHiddenInputOrganizationIdTarget) {
        this.hiddenInputOrganizationIdTarget.value = organizationId;
      }
      
      const formData = new FormData();
      formData.append('referral[referred_organization_id]', organizationId);
      this.getReferralForm(organizationId, formData);
      
      // Clear the URL parameter to prevent re-triggering on refresh
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  } 

  initializeTooltips() {
    // Initialize any existing tooltips within this controller's element
    const tooltipTriggerList = [].slice.call(
      this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach(function(tooltipTriggerEl) {
      new Tooltip(tooltipTriggerEl);
    });
  }

  initReferredProviderBtnsWrapper() {
    this.referredProviderBtnsWrapperTarget.classList.remove("d-none");
    this.addNewReferredProviderBtnTarget.classList.remove("d-none");
    this.chooseExistingReferredProviderBtnTarget.classList.add("d-none");
  }

  getReferredLocations(organizationId) {
    $.ajax({
      url: `/referrals/locations_by_organization`,
      type: "GET",
      dataType: "html",
      data: { organization_id: organizationId },
      success: (data) => {
        // Find the location wrapper specifically
        const locationWrapper = this.customSelectWrapperTargets.find(wrapper => 
          wrapper.querySelector('.custom-select-value[data-step1-create-referral-target="inputReferredLocation"]')
        );
        if (locationWrapper) {
          locationWrapper.querySelector('.result-items').innerHTML = data;
          this.initializeTooltips();
        }
      }
    });
  }

  getReferredProviders(organizationId, locationIds = null) {
    const params = { organization_id: organizationId };
  
    if (locationIds) {
      params.location_ids = locationIds;
    }
    $.ajax({
      url: `/referrals/providers_by_organization`,
      type: "GET",
      dataType: "html",
      data: params,
      success: (data) => {
        // Find the provider wrapper specifically
        const providerWrapper = this.customSelectWrapperTargets.find(wrapper => 
          wrapper.querySelector('.custom-select-value[data-step1-create-referral-target="inputReferredProvider"]')
        );
        if (providerWrapper) {
          providerWrapper.querySelector('.result-items').innerHTML = data;
          this.initializeTooltips();
        }
      },
      error: (error) => {
        this.hasReferredProviderDzItemsTarget && (this.referredProviderDzItemsTarget.innerHTML = '')
      }
    });
  }

  getReferralForm(organizationId, formData) {
    const param = organizationId == 'new' ? 'to_email=true' : ''
    // The response replaces the whole form, including whichever field is
    // focused (the organization search box). On iOS 27 WebKit, swapping the
    // DOM under an open keyboard leaves the web view white, so drop the
    // keyboard first and give it a beat before rendering.
    this.dismissKeyboard()
    $.ajax({
      url: `/referrals/referral_form_by_organization?${param}`,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: (response) => {
        this.dismissKeyboard()
        setTimeout(() => {
          Turbo.renderStreamMessage(response);
          setTimeout(() =>  this.hideOverlay(), 100);
          this.initializeTooltips();
        }, 150);
      },
    });
  }

  dismissKeyboard() {
    const active = document.activeElement
    if (active && active !== document.body && typeof active.blur === 'function') active.blur()
  }

  setHoverReferredOrganizationSelection() {
    this.referredOrganizationDzItemsTarget
      .querySelectorAll("li")
      .forEach((li) => {
        li.classList.remove("hover-selection");
        if (li.dataset.selectId == this.hiddenInputOrganizationIdTarget.value)
          li.classList.add("hover-selection");
      });
  }

  customSelectWrapperTargetConnected(element) {
    const inputField = $(element).find('.custom-select-value');
    const resultContainer = $(element).find('.result-container');
    const hiddenField = element.querySelector('.custom-select-hidden-field');
    
    if (inputField && inputField.length) {
      // Use the existing method to set the placeholder
      const domInputField = inputField[0];
      if (!inputField.val() || inputField.val().trim() === '') {
        this.clearInputWithPlaceholder(domInputField);
      }
    }
    
  // Modified click handler to close other dropdowns first
  inputField.on("click", (e) => {
    // First close all other open result containers
    this.closeAllDropdownsExcept(element);
    
    // Then toggle this one
    if (resultContainer.is(":visible")) {
      resultContainer.addClass("d-none");
    } else {
      resultContainer.removeClass("d-none");
    }
    e.stopPropagation();
  });

    resultContainer.on("mousedown", function(e) {
      e.preventDefault();
    });
  
    // Add delegate event handler for all list items in this dropdown
    $(element).find('.result-items').on('click', 'li', (e) => {
      this.handleCustomSelectItemClick(e);
    });
  
    // Create a click handler that's scoped to this specific dropdown
    $(document).on("click", (e) => {
      // Only run this check for this specific dropdown
      if (!$(e.target).closest(element).length) {
        resultContainer.addClass("d-none");
      }
    });
  }

  closeAllDropdownsExcept(exceptElement) {
    this.customSelectWrapperTargets.forEach(wrapper => {
      if (wrapper !== exceptElement) {
        $(wrapper).find('.result-container').addClass('d-none');
      }
    });
  }
  
  handleCustomSelectItemClick(e) {
    const item = e.currentTarget;
    const checkbox = item.querySelector('.location-checkbox, .provider-checkbox');
    const wrapper = $(item).closest('.custom-select-wrapper')[0];
    const hiddenField = wrapper.querySelector('.custom-select-hidden-field');
    const displayField = wrapper.querySelector('.custom-select-value');
    const isMultiple = $(wrapper).attr('data-type') === 'multiple';
    
    // Check if this is a provider checkbox or location checkbox
    const isProviderCheckbox = checkbox && checkbox.classList.contains('provider-checkbox');
    const isLocationCheckbox = checkbox && checkbox.classList.contains('location-checkbox');
    
    // Handle multi-select with checkboxes
    if (isMultiple && checkbox) {
      // If trying to check (not uncheck) and already have 3 selected, prevent selection
      if (!checkbox.checked) {
        const checkboxSelector = isLocationCheckbox ? 
          '.location-checkbox:checked' : '.provider-checkbox:checked';
        const selectedItems = wrapper.querySelectorAll(checkboxSelector);
        
        if (selectedItems.length >= 3) {
          // Show appropriate warning
          if (isLocationCheckbox && this.hasLocationLimitWarningTarget) {
            this.locationLimitWarningTarget.classList.remove('d-none');
            setTimeout(() => {
              this.locationLimitWarningTarget.classList.add('d-none');
            }, 3000);
          } else if (isProviderCheckbox && this.hasProviderLimitWarningTarget) {
            this.providerLimitWarningTarget.classList.remove('d-none');
            setTimeout(() => {
              this.providerLimitWarningTarget.classList.add('d-none');
            }, 3000);
          }
          
          e.preventDefault();
          return; // Don't allow selection
        }
      }
      
      checkbox.checked = !checkbox.checked;
      
      if (checkbox.checked) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }
      
      const checkboxClass = checkbox.classList.contains('location-checkbox') ? 
        '.location-checkbox:checked' : '.provider-checkbox:checked';
      const selectedItems = wrapper.querySelectorAll(checkboxClass);
      
      const selectedIds = Array.from(selectedItems).map(cb => 
        cb.closest('li').dataset.selectId
      );
      
      const selectedLabels = Array.from(selectedItems).map(cb => 
        cb.closest('li').dataset.selectLabel
      );
      
      hiddenField.value = selectedIds

      // Leave the display empty when nothing is selected so the floating label
      // (and its placeholder) behaves like the other inputs.
      displayField.value = selectedLabels.length > 0 ?
        selectedLabels.join(', ') : "";

      if (isLocationCheckbox) {
        // Get organization ID - handle both regular and embedded forms
        let organizationId;
        
        if (this.hasHiddenInputOrganizationIdTarget) {
          // Regular form
          organizationId = this.hiddenInputOrganizationIdTarget.value;
        } else {
          // Embedded form - find org ID from hidden field
          const orgField = document.querySelector('input[name="referral[referred_organization_id]"]');
          if (orgField) {
            organizationId = orgField.value;
          }
        }
        
        if (organizationId) {
          if (selectedIds.length > 0) {
            // If locations are selected, filter providers by these locations
            this.getReferredProviders(organizationId, selectedIds.join(','));
          } else {
            // If no locations selected, get all providers for the organization
            this.getReferredProviders(organizationId);
          }
        }
      }        

    }
    // Single select 
    else {
      hiddenField.value = item.dataset.selectId;
      displayField.value = item.dataset.selectLabel;
      
      $(item).siblings().removeClass('hover-selection');
      $(item).addClass('hover-selection');
      
      // If this is a provider field, set to specific provider
      if (hiddenField === this.hiddenInputReferredProviderIdsTarget) {
        this.referredProviderTypeHiddenTarget.value = 'specific_provider'; // specific_provider value
      }
      
      // Close dropdown for single-select items
      const resultContainer = $(wrapper).find('.result-container');
      resultContainer.addClass('d-none');
    }
    
    // When checking submit button, skip if in embedded form
    if (!this.isEmbeddedForm) {
      this.checkSubmitButton();
      checkNewReferralFormSubmitButton();
    }
    
    e.stopPropagation(); // Prevent event bubbling up
    e.preventDefault();
  }

  referralFormTargetConnected() {
    if (this.hiddenInputOrganizationIdTarget.value) {
      this.checkSubmitButton();
      checkNewReferralFormSubmitButton();

      this.referralFormTarget.addEventListener("input", () => {
        this.checkSubmitButton();
        checkNewReferralFormSubmitButton();
      });

      this.disableReferredOrganizationNewFields(true);
      this.disableReferredProviderNewFields(true);
    }

    this.restorePreservedEmailFields();

    if (this.newOrganizationEmailTarget.value) {
      // this.addNewOrganizationClick();

      this.checkSubmitButton(
        true,
        this.newOrganizationEmailTarget.value.trim()
      );
      checkNewReferralFormSubmitButton();
    }
  }

  // After the form re-renders into office-email mode, repopulate the email
  // fields the user previously typed (kept out of the submission via the stash).
  restorePreservedEmailFields() {
    // Disabled means we're in "choose existing organization" mode — nothing to do.
    if (this.newOrganizationEmailTarget.disabled) return;

    if (!this.newOrganizationEmailTarget.value && this.preservedRecipientFields.email) {
      this.newOrganizationEmailTarget.value = this.preservedRecipientFields.email;
    }
    if (!this.newOrganizationNameTarget.value && this.preservedRecipientFields.preferredName) {
      this.newOrganizationNameTarget.value = this.preservedRecipientFields.preferredName;
    }
  }

  addNewOrganizationClick(e) {
    // Preserve the currently-selected organization so it can be restored if the
    // user switches back. It stays out of the submission because its inputs are
    // disabled below, not because we blank it.
    this.preservedRecipientFields.organizationId = this.hiddenInputOrganizationIdTarget.value;
    this.preservedRecipientFields.organizationName =
      this.inputOrganizationTarget.value ||
      this.hiddenInputOrganizationIdTarget.dataset.organizationName || "";
    this.preservedRecipientFields.referredProviderId = this.hiddenInputReferredProviderIdsTarget.value;
    this.preservedRecipientFields.referredProviderName = this.inputReferredProviderTarget.value;

    this.referredOrganizationFieldsWrapperTarget.classList.remove("d-none");
    this.chooseExistingOrganizationBtnTarget.classList.remove("d-none");
    this.addNewOrganizationBtnTarget.classList.add("d-none");
    this.referredProviderBtnsWrapperTarget.classList.add("d-none");
    this.addReferredProviderWrapperTarget.classList.add("d-none");
    this.submitBtnTarget.classList.add("btn-lock");
    const inputOrgValue = this.inputOrganizationTarget.value

    this.hiddenInputReferredProviderIdsTarget.value = "";
    this.hiddenInputOrganizationIdTarget.value = "";
    this.inputOrganizationTarget.value = "";

    //this.disableReferredProviderType(false);
    this.disableReferredProviderIdInput(true)
    this.disableReferredOrganizationIdInput(true);
    this.disableReferredOrganizationNewFields(false);
    this.checkReferredProviderType();

    const newOrgType = e.currentTarget.dataset.newOrgType;

    if(newOrgType == 'invitation'){
      const name = e.currentTarget.dataset.name;
      const email = e.currentTarget.dataset.email;
      this.newOrganizationNameTarget.value = name;
      this.newOrganizationEmailTarget.value = email;
    }

    const preserveInputOrgField = e.target && e.target.dataset.preserveField
    if (inputOrgValue && preserveInputOrgField)
      this.newOrganizationEmailTarget.value = inputOrgValue;

    this.showOverlay(); 
    const formData = new FormData(e.target.closest('form'))
    this.getReferralForm("new", formData)

    this.newOrganizationEmailTarget.addEventListener("input", () => {
      this.checkSubmitButton(
        true,
        this.newOrganizationEmailTarget.value.trim()
      );
      checkNewReferralFormSubmitButton();
    });

  }

  addNewReferredProviderBtnClick() {
    this.disableReferredProviderIdInput(true);
    this.disableReferredProviderNewFields(false);
    this.disableReferredLocationIdInput(true)
    this.addNewReferredProviderBtnTarget.classList.add("d-none");
    this.chooseExistingReferredProviderBtnTarget.classList.remove("d-none");
    this.checkSubmitButton();
    checkNewReferralFormSubmitButton();
  }

  inputOrganizationTargetConnected(e) {
    e.addEventListener("focusout", (e) => {
      setTimeout(() => {
        // Set the input organization value to the selected organization name until the user deletes all the characters.
        if (this.hiddenInputOrganizationIdTarget.value.length) {
          e.target.value =
            this.hiddenInputOrganizationIdTarget.dataset.organizationName;
        }
        this.dropzoneTarget.classList.add("d-none");
      }, 200);
    });
  }

  searchOrganizations(e) {
    setTimeout(() => {
      const searchText = e.target.value;

      if (!searchText.length) {
        // Set the hidden referred organization id and the hidden referred provider id value to empty.
        this.hiddenInputOrganizationIdTarget.value = "";
        this.hiddenInputReferredProviderIdsTarget.value = "";
        // Hidden all the fields.
        this.chooseExistingOrganizationBtnTarget.classList.add("d-none");
        this.addReferredProviderWrapperTarget.classList.add("d-none");
        this.dropzoneTarget.classList.add("d-none");
        
        this.showOverlay();

        // Check the submit button.
        this.checkSubmitButton();
        checkNewReferralFormSubmitButton();
        return;
      }

      $.ajax({
        url: `/referrals/referred_organizations`,
        type: "GET",
        dataType: "HTML",
        data: { search_text: searchText },
        success: (data) => {
          this.referredOrganizationDzItemsTarget.innerHTML = data;
          this.setHoverReferredOrganizationSelection();
          this.addEmailTarget.innerHTML = "Add " + searchText;
        },
      });

      this.dropzoneTarget.classList.remove("d-none");
    }, 300);
  }

  fetchOrganizations(e) {
    $.ajax({
      url: `/referrals/referred_organizations`,
      type: "GET",
      dataType: "HTML",
      data: e.target.value ? { search_text: e.target.value } : {},
      success: (data) => {
        this.referredOrganizationDzItemsTarget.innerHTML = data;
        this.setHoverReferredOrganizationSelection();
      },
    });
    this.dropzoneTarget.classList.remove("d-none");
  }

  disableReferredProviderNewFields(value) {
    if (value) {
      this.referredProviderFieldsWrapperTarget.classList.add("d-none");
      this.referredProviderFieldsWrapperTarget
        .querySelectorAll("input")
        .forEach((input) => (input.disabled = true));
    } else {
      this.referredProviderFieldsWrapperTarget.classList.remove("d-none");
      this.referredProviderFieldsWrapperTarget
        .querySelectorAll("input")
        .forEach((input) => (input.disabled = false));
    }
  }

  disableReferredOrganizationNewFields(value) {
    if (value) {
      this.referredOrganizationFieldsWrapperTarget
        .querySelectorAll("input")
        .forEach((input) => (input.disabled = true));
    } else {
      this.referredOrganizationFieldsWrapperTarget
        .querySelectorAll("input")
        .forEach((input) => (input.disabled = false));
    }
  }

  disableReferredOrganizationIdInput(value) {
    if (value) {
      this.inputOrganizationWrapperTarget.classList.add("d-none");
      this.hiddenInputOrganizationIdTarget.disabled = true;
      this.hiddenInputOrganizationIdTarget.value = "";
    } else {
      this.inputOrganizationWrapperTarget.classList.remove("d-none");
      this.hiddenInputOrganizationIdTarget.disabled = false;
    }
  }

  disableReferredProviderIdInput(value) {
    // Find the provider custom-select-wrapper
    const providerWrapper = this.element.querySelectorAll('.custom-select-wrapper')[1]; 
    
    if (value) {
      providerWrapper.classList.add("d-none");
      this.hiddenInputReferredProviderIdsTarget.disabled = true;
      this.hiddenInputReferredProviderIdsTarget.value = "";
      this.inputReferredProviderTarget.value = "";
      if (this.hasInputReferredProviderTarget) {
        this.clearInputWithPlaceholder(this.inputReferredProviderTarget);
      }
    } else {
      providerWrapper.classList.remove("d-none");
      this.hiddenInputReferredProviderIdsTarget.disabled = false;
    }
  }

  disableReferredLocationIdInput(value) {
    // Find the provider custom-select-wrapper
    const providerWrapper = this.element.querySelectorAll('.custom-select-wrapper')[1]; 
    
    if (value) {
      providerWrapper.classList.add("d-none");
      this.hiddenInputReferredLocationIdsTarget.disabled = true;
      this.hiddenInputReferredLocationIdsTarget.value = "";
      this.inputReferredLocationTarget.value = "";
      if (this.hasInputReferredLocationTarget) {
        this.clearInputWithPlaceholder(this.inputReferredLocationTarget);
      }
    } else {
      providerWrapper.classList.remove("d-none");
      this.hiddenInputReferredLocationIdsTarget.disabled = false;
    }
  }

  checkReferredProviderType() {
    const hasSelectedProvider = this.hiddenInputReferredProviderIdsTarget.value.trim() !== '';
    this.referredProviderTypeHiddenTarget.value = 'any_provider';
    
    this.checkSubmitButton();
    checkNewReferralFormSubmitButton();
  }

  clearInputWithPlaceholder(inputField, hiddenField = null) {
    // Clear the actual stored value if hidden field is provided
    if (hiddenField) hiddenField.value = "";

    // Clear the display value so the floating label / placeholder takes over
    // instead of stuffing the hint text in as a real value.
    inputField.value = "";
  }

  selectOrganizationClick(e) {
    const { organizationId, organizationName, providerId, providerName } =
      e.currentTarget.dataset;

    this.selectOrganization({
      organizationId,
      organizationName,
      providerId,
      providerName,
      hoverItem: e.currentTarget,
    });
  }

  selectOrganization({ organizationId, organizationName, providerId, providerName, hoverItem = null }) {
    this.showOverlay()

    this.inputReferredProviderTarget.value = "";
    this.hiddenInputReferredProviderIdsTarget.value = "";

    this.inputReferredLocationTarget.value = "";
    this.hiddenInputReferredLocationIdsTarget.value = "";

    this.clearInputWithPlaceholder(
      this.inputReferredProviderTarget,
      this.hiddenInputReferredProviderIdsTarget
    );

    this.clearInputWithPlaceholder(
      this.inputReferredLocationTarget,
      this.hiddenInputReferredLocationIdsTarget
    );

    this.hiddenInputOrganizationIdTarget.value = organizationId;
    this.hiddenInputOrganizationIdTarget.dataset.organizationName =
      organizationName;
    this.inputOrganizationTarget.value = organizationName;

    if(providerId){
      this.hiddenInputReferredProviderIdsTarget.value = providerId;
      this.inputReferredProviderTarget.value = providerName;
    }

    // this.getReferredProviders(organizationId, providerId);
    // this.getReferredLocations(organizationId);
    const formData = new FormData(this.element.closest('form'))
    this.getReferralForm(organizationId, formData);

    if (hoverItem) {
      hoverItem
        .closest("ul")
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("hover-selection"));
      hoverItem.classList.add("hover-selection");
    }

    this.addReferredProviderWrapperTarget.classList.remove("d-none");
    // Show both wrappers - location and provider
    // this.customSelectWrapperTargets.forEach(wrapper => {
    //   wrapper.classList.remove("d-none");
    // });

    this.initReferredProviderBtnsWrapper();
    //this.disableReferredProviderType(true);
    this.disableReferredOrganizationNewFields(true);
    this.disableReferredProviderNewFields(true);
    this.disableReferredProviderIdInput(false);
    // this.hideOverlay();
    this.checkReferredProviderType();
    this.checkSubmitButton();
    checkNewReferralFormSubmitButton();
  }


  chooseExistingReferredProviderBtnClick() {
    this.disableReferredProviderIdInput(false);
    this.disableReferredProviderNewFields(true);
    this.chooseExistingReferredProviderBtnTarget.classList.add("d-none");
    this.addNewReferredProviderBtnTarget.classList.remove("d-none");
    this.checkSubmitButton();
    checkNewReferralFormSubmitButton();
  }

  chooseExistingOrganizationClick() {
    // Preserve whatever was typed for the office email so it isn't lost on the
    // toggle. The fields are disabled below so they won't be submitted.
    this.preservedRecipientFields.email = this.newOrganizationEmailTarget.value;
    this.preservedRecipientFields.preferredName = this.newOrganizationNameTarget.value;

    this.referredOrganizationFieldsWrapperTarget.classList.add("d-none");
    this.chooseExistingOrganizationBtnTarget.classList.add("d-none");
    this.addReferredProviderWrapperTarget.classList.add("d-none");
    this.addNewOrganizationBtnTarget.classList.remove("d-none");

    this.newOrganizationEmailTarget.value = null;
    //this.disableReferredProviderType(true);

    this.disableReferredOrganizationIdInput(false);
    this.disableReferredOrganizationNewFields(true);

    // Restore a previously-selected organization, if there was one.
    if (this.preservedRecipientFields.organizationId) {
      this.selectOrganization({
        organizationId: this.preservedRecipientFields.organizationId,
        organizationName: this.preservedRecipientFields.organizationName,
        providerId: this.preservedRecipientFields.referredProviderId,
        providerName: this.preservedRecipientFields.referredProviderName,
      });
      return;
    } else if (this.preservedRecipientFields.organizationName) {
      // Organization name was typed but never selected — restore the search text.
      this.inputOrganizationTarget.value = this.preservedRecipientFields.organizationName;
    }

    this.showOverlay();
    this.checkReferredProviderType();
    this.checkSubmitButton();
    checkNewReferralFormSubmitButton();
  }

  checkSubmitButton(skipValidation = false, isValidateEmail = false) {
    // Skip for embedded forms
    if (this.isEmbeddedForm || !this.hasSubmitBtnTarget) return;

    if (skipValidation) {
      this.submitBtnTarget.classList.toggle("btn-lock", !isValidateEmail);
    } else {
      setTimeout(() => {
        const requiredFields = this.referralFormTarget.querySelectorAll(
          "input[type=text][required]:not([disabled]), input[type=hidden][required]:not([disabled])"
        );
        const isAnyUnfilledFields = [...requiredFields].some(
          (field) => !field.value.trim()
        );

        this.submitBtnTarget.classList.toggle("btn-lock", isAnyUnfilledFields);
      }, 200);
    }
  }

  toggleFields(event) {
    this.sharedProviderFieldTarget.classList.toggle('d-none');
    
    // Toggle chevron direction
    const chevron = event.currentTarget.querySelector('i');
    if (chevron) {
      chevron.classList.toggle('fa-chevron-right');
      chevron.classList.toggle('fa-chevron-down');
    }
  }

}
